import Highcharts from 'highcharts';

import stockInit from 'highcharts/modules/stock';
import exportingInit from 'highcharts/modules/exporting';
import { priceFormat } from '../helpers/helpers';

stockInit(Highcharts);
exportingInit(Highcharts);

export default {
    data() {
        return {
            hcInstance: null,
            range: null,
            chartOptions: {
                accessibility: {
                    enabled: false,
                },
                chart: {
                    height: 485,
                    zoomType: 'x',
                    animation: {
                        duration: 1000,
                    },
                    marginRight: 0,
                },
                credits: {
                    enabled: false,
                },
                time: {
                    useUTC: true,
                },
                rangeSelector: {
                    enabled: false,
                },
                animation: true,
                xAxis: {
                    crosshair: {
                        label: {
                            type: 'datetime',
                            enabled: true,
                            format: '{value:%m/%d/%Y %I:%M %p}',
                            backgroundColor: '#666666',
                        },
                    },
                    type: 'datetime',
                    dateTimeLabelFormats: {
                        day: '%d. %b',
                        hour: '%I:%M %p',
                    },
                },
                yAxis: [
                    {
                        plotLines: [{
                            color: 'grey',
                            dashStyle: 'dot',
                            width: 1,
                            label: {
                                x: -75,
                                y: 0,
                                useHTML: true,
                                formatter() {
                                    const { value } = this.options;

                                    return priceFormat(value, true);
                                },
                            },
                            lineWidth: 1,
                        }],
                        height: '80%',
                        opposite: false,
                        labels: {
                            formatter(value) {
                                return priceFormat(value.value, true, true);
                            },
                        },
                        crosshair: {
                            dashStyle: 'dot',
                            width: 1,
                            color: 'grey',
                            snap: false,
                            label: {
                                enabled: true,
                                useHTML: true,
                                formatter(value) {
                                    return priceFormat(value, true);
                                },
                            },
                        },
                        lineColor: '#e6e6e6',
                        lineWidth: 1,
                    },
                    {
                        opposite: false,
                        top: '80%',
                        height: '20%',
                        offset: 0,
                        crosshair: {
                            dashStyle: 'dot',
                            width: 1,
                            color: 'grey',
                            snap: false,
                            label: {
                                enabled: true,
                                formatter(value) {
                                    return priceFormat(value, true);
                                },
                            },
                        },
                        lineColor: '#e6e6e6',
                        lineWidth: 1,
                        labels: {
                            enabled: false,
                        },
                    },
                ],
                navigation: {
                    menuItemHoverStyle: {
                        background: '#f8fafd',
                        color: '#000000',
                    },
                    contextMenuStyle: {
                        border: 'none',
                    },
                    buttonOptions: {
                        height: 25,
                        y: 0,
                    },
                },
                navigator: {
                    series: {
                        color: '#3861FB',
                        fillColor: 'rgba(56,97,251, 0.1)',
                    },
                    outlineWidth: 0,
                    maskFill: 'rgba(56, 98, 251, 0.08)',
                    xAxis: {
                        type: 'datetime',
                        dateTimeLabelFormats: {
                            day: '%d. %b',
                            hour: '%I:%M %p',
                        },
                        tickPixelInterval: 100,
                    },
                },
                responsive: {
                    rules: [{
                        chartOptions: {
                            chart: {
                                marginRight: 0,
                            },
                            tooltip: {
                                followPointer: false,
                                positioner(labelWidth, labelHeight, point) {
                                    const tooltipX = this.chart.plotLeft;
                                    let tooltipY = (point.plotY) - this.chart.plotTop;

                                    if ((point.plotY - labelHeight - this.chart.plotTop) > this.chart.plotTop) {
                                        tooltipY = (point.plotY - 100) + this.chart.plotTop - 20;
                                    }

                                    return {
                                        x: tooltipX,
                                        y: tooltipY,
                                    };
                                },
                            },
                        },
                        condition: {
                            maxWidth: 540,
                        },
                    }],
                },
                tooltip: {
                    followTouchMove: true,
                    followPointer: true,
                    borderColor: 'none',
                    backgroundColor: 'white',
                    borderRadius: '8',
                    shadow: false,
                    shared: true,
                    split: false,
                    useHTML: true,
                    positioner(labelWidth, labelHeight, point) {
                        let tooltipX = (point.plotX) + this.chart.plotLeft + 20;
                        let tooltipY = (point.plotY - 60) - this.chart.plotTop + labelHeight;

                        if (point.plotX + labelWidth + 20 > this.chart.plotWidth) {
                            tooltipX = (point.plotX) + this.chart.plotLeft - labelWidth - 20;
                        }

                        if ((point.plotY - labelHeight - this.chart.plotTop) > this.chart.plotTop) {
                            tooltipY = (point.plotY - 100) + this.chart.plotTop - 20;
                        }

                        return {
                            x: tooltipX,
                            y: tooltipY,
                        };
                    },
                },
                exporting: {
                    enabled: false,
                },
            },
        };
    },
    mounted() {
        Highcharts.removeEvent(Highcharts.Chart, 'beforeShowResetZoom');
    },
    methods: {
        chartExportOptions() {
            return {
                chart: {
                    events: {
                        load() {
                            this.renderer.image('https://images.bitdegree.org/crypto-prices/assets/bitdegree-watermark.png', 1070, 410, 120, 34)
                                .add();
                        },
                    },
                },
                yAxis: {
                    plotLines: [{
                        label: {
                            text: '',
                        },
                        lineWidth: 1,
                    }],
                },
                navigator: {
                    enabled: false,
                },
                scrollbar: {
                    enabled: false,
                },
            };
        },
        exportImage(name, type) {
            const filename = this.currency_code ? `${this.currency_code}_${this.range.toUpperCase()}_${name}_chart` : `${this.range.toUpperCase()}_${name}_chart`;
            this.hcInstance.chart.exportChart({
                type,
                filename,
                sourceWidth: 1200,
                sourceHeight: 600,
            }, this.chartExportOptions());
        },
        toggleFs() {
            this.hcInstance.chart.fullscreen.toggle();
        },
        toggleLogAxes(isLogarithmic) {
            this.hcInstance.chart.update({
                yAxis: {
                    type: isLogarithmic ? 'liner' : 'logarithmic',
                },
            });
        },
    },
};
